<template>
  <teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content" role="dialog" aria-modal="true">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('logs_ticket') }}</h5>
          <button type="button" class="btn-close" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <button class="logout-button" @click="exportToExcel" style="margin-bottom: 10px;">
            {{ $t('exportar_logs') }}
          </button>
          <div class="logs-container">
            <table class="logs-table">
              <thead>
                <tr>
                  <th>{{ $t('id') }}</th>
                  <th>{{ $t('accion') }}</th>
                  <th>{{ $t('usuario') }}</th>
                  <th>{{ $t('fecha') }}</th>
                  <th>{{ $t('detalles') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="logs.length === 0">
                  <td colspan="5" style="text-align: center;">{{ $t('no_registros') }}</td>
                </tr>
                <tr v-for="(log, index) in logs" :key="index">
                  <td>{{ log.id }}</td>
                  <td>{{ log.campo_cambiado }}</td>
                  <td>{{ log.usuario?.nombre_completo || $t('desconocido') }}</td>
                  <td>{{ log.fecha_cambio }}</td>
                  <td>
                    <div v-if="log.valor_anterior || log.valor_nuevo">
                      <div v-if="log.valor_anterior">
                        {{ $t('anterior') }}:
                        <span v-if="log.campo_cambiado === 'estado_id'">
                          {{ getNombreEstado(log.valor_anterior) }}
                        </span>
                        <span v-else-if="log.campo_cambiado === 'usuario_asignado_id'">
                          {{ getNombreUsuario(log.valor_anterior) }}
                        </span>
                        <span v-else-if="log.campo_cambiado === 'prioridad_id'">
                          {{ getNombrePrioridad(log.valor_anterior) }}
                        </span>
                        <span v-else>
                          {{ log.valor_anterior }}
                        </span>
                      </div>
                      <div v-if="log.valor_nuevo">
                        {{ $t('nuevo') }}:
                        <span v-if="log.campo_cambiado === 'estado_id'">
                          {{ getNombreEstado(log.valor_nuevo) }}
                        </span>
                        <span v-else-if="log.campo_cambiado === 'usuario_asignado_id'">
                          {{ getNombreUsuario(log.valor_nuevo) }}
                        </span>
                        <span v-else-if="log.campo_cambiado === 'prioridad_id'">
                          {{ getNombrePrioridad(log.valor_nuevo) }}
                        </span>
                        <span v-else>
                          {{ log.valor_nuevo }}
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      {{ log.valor_nuevo || $t('n_a') }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import api from '../api';
import * as XLSX from 'xlsx';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    ticketId: {
      type: Number,
      required: true,
    },
    usuarios: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      logs: [],
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchLogs();
        }
      },
    },
  },
  methods: {
    getNombrePrioridad(prioridadId) {
      const map = {
        1: this.$t('baja'),
        2: this.$t('media'),
        3: this.$t('alta'),
        '1': this.$t('baja'),
        '2': this.$t('media'),
        '3': this.$t('alta'),
      };
      return map[prioridadId] || prioridadId;
    },
    async fetchLogs() {
      try {
        const response = await api.get(`/tickets/${this.ticketId}/logs`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('auth_token')}`,
          },
        });
        this.logs = Array.isArray(response.data.logs) ? response.data.logs : [];
      } catch (error) {
        console.error('Error al cargar los logs del ticket:', error.response?.data || error.message);
        this.logs = [];
      }
    },
    closeModal() {
      this.$emit('close');
    },
    getNombreEstado(estadoId) {
      const estados = {
        1: 'Abierto',
        2: 'En Progreso',
        3: 'Cerrado',
      };
      return estados[estadoId] || 'Desconocido';
    },
    getNombreUsuario(id) {
      const usuario = (this.usuarios || []).find(u => u.id == id);
      return usuario ? usuario.nombre_completo : id;
    },
    exportToExcel() {
      const header = [
        this.$t('id'),
        this.$t('accion'),
        this.$t('usuario'),
        this.$t('fecha'),
        this.$t('detalles')
      ];
      const data = this.logs.map(log => [
        log.id,
        log.campo_cambiado,
        log.usuario?.nombre_completo || this.$t('desconocido'),
        log.fecha_cambio,
        (() => {
          let detalles = '';
          if (log.valor_anterior) {
            detalles += this.$t('anterior') + ': ';
            if (log.campo_cambiado === 'estado_id') {
              detalles += this.getNombreEstado(log.valor_anterior);
            } else if (log.campo_cambiado === 'usuario_asignado_id') {
              detalles += this.getNombreUsuario(log.valor_anterior);
            } else if (log.campo_cambiado === 'prioridad_id') {
              detalles += this.getNombrePrioridad(log.valor_anterior);
            } else {
              detalles += log.valor_anterior;
            }
            detalles += '\n';
          }
          if (log.valor_nuevo) {
            detalles += this.$t('nuevo') + ': ';
            if (log.campo_cambiado === 'estado_id') {
              detalles += this.getNombreEstado(log.valor_nuevo);
            } else if (log.campo_cambiado === 'usuario_asignado_id') {
              detalles += this.getNombreUsuario(log.valor_nuevo);
            } else if (log.campo_cambiado === 'prioridad_id') {
              detalles += this.getNombrePrioridad(log.valor_nuevo);
            } else {
              detalles += log.valor_nuevo;
            }
          }
          return detalles || log.valor_nuevo || this.$t('n_a');
        })()
      ]);
      const allRows = [header, ...data];
      const ws = XLSX.utils.aoa_to_sheet(allRows);

      // Ajuste automático de ancho de columnas
      const colWidths = header.map((_, colIdx) => ({
        wch: Math.max(
          ...allRows.map(row => (row[colIdx] ? String(row[colIdx]).length : 0)),
          10
        )
      }));
      ws['!cols'] = colWidths;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "LogsTicket");
      XLSX.writeFile(wb, "logs_ticket.xlsx");
    }
  },
};
</script>

<style scoped>
/* Estilos del modal */

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #99172A;
  color: white;
  padding: 10px 20px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
    left: 0px;
  top: 0px;
}

.modal-header .btn-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: white;
}

.modal-body {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.logs-container {
  max-height: 400px;
  overflow-y: auto;
  margin-top: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.logs-table {
  width: 100%;
  border-collapse: collapse;
}

.logs-table thead th {
  background-color: #f5f5f5;
  color: #333;
  text-align: left;
  padding: 10px;
  border: 1px solid #ddd;
  position: sticky;
  top: 0;
  z-index: 2;
}

.logs-table tbody td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.logout-button {
  background-color: #798a99;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 6px 12px;      /* Igual que el select */
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 38px;           /* Altura similar al select */
  min-height: unset;      /* Elimina restricciones previas */
  box-sizing: border-box;
}

.logout-button:hover {
  background-color: #5e6e7a;

}

.modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.9); /* opacidad 0.9 */
  z-index: 130000 !important; /* por encima de WelcomeView y Swal */
  padding: 16px;
  box-sizing: border-box;
}
</style>